export default __webpack_public_path__ + "static/media/10.17b06dae.jpg";